import styled from 'styled-components';
import { bool } from 'prop-types';
import JourneyTooltip from 'apps/journey/components/tooltip';

const HoverJourneyTooltip = styled(JourneyTooltip)`
  position: ${(props) => (props.relative ? 'relative' : 'absolute')};
`;

HoverJourneyTooltip.propTypes = {
  relative: bool,
};

export default HoverJourneyTooltip;
